import { TmcContextService } from './../../../../common/tmc-context.service';
import { Component } from '@angular/core';
import { ContextChange } from '@sdbn/common';
import { TransportDetailsService } from '../../service/transport-details.service';
import { AbstractWidgetComponent } from '@sdbn/common';
import { TransportOptionColumn, TransportOptionsPanelModel, TransportOption, TransportOptionSelection } from '../../../../components/transport-options-panel/transport-options-panel.model';
import { Subscription } from 'rxjs';
import { YardConfiguration } from '../../../../client/model/yard-configuration';

export class OptionsColumn {
  columnIndex: number;
  transportOptions = new Array<TransportOption>();
}

@Component({
    selector: 'app-transport-options',
    templateUrl: './transport-options.component.html',
    styleUrls: ['./transport-options.component.scss'],
    standalone: false
})
export class TransportOptionsComponent extends AbstractWidgetComponent {

  transport: any;
  yardConfiguration: YardConfiguration;

  tmcContextSubscription: Subscription;

  model: TransportOptionsPanelModel;

  constructor(
    private tmcContextService: TmcContextService,
    private transportDetailsService: TransportDetailsService
  ) {
    super();
    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(yardConfiguration => {
      this.yardConfiguration = yardConfiguration;
      this.createTransportOptionsModel();
    });
  }

  onContextChange(contextChange: ContextChange) { }

  onSetElementAndContext() {
    this.transport = this.dashboardContext.context.get('selected-transport');
    this.createTransportOptionsModel();

  }

  createTransportOptionsModel() {
    if (this.transport != null && this.yardConfiguration != null) {

      let columns = new Array<TransportOptionColumn>();
      for (let option of this.yardConfiguration.transportOptions) {
        while (option.columnIndex != null && columns.length < option.columnIndex + 1) {
          let column = new TransportOptionColumn();
          columns.push(column);
        }
        let column = columns[option.columnIndex];
        column.options.push(new TransportOption(option));
      }
      this.transportDetailsService.getTransportOptions({ id: this.transport.id }).subscribe(
        transportOptions => {

          const selection = new Array<TransportOptionSelection>();
          for (const option of transportOptions) {
            const newOption = new TransportOptionSelection(option);
            newOption.selected = true;
            selection.push(newOption);
          }

          this.model = new TransportOptionsPanelModel({
            columns: columns,
            constraints: this.yardConfiguration.transportOptionConstraints,
            selection: selection,
            readOnly: true
          });
        }
      );
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.tmcContextSubscription) {
      this.tmcContextSubscription.unsubscribe();
      this.tmcContextSubscription = null;
    }
  }
}
